import React, { useEffect, useState, useContext } from 'react';
import Helmet from 'react-helmet';
import { PageContext } from '@/context/PageContext';

import Section from '@latitude/section';
import { Link } from '@latitude/link';
import { Heading4 } from '@latitude/heading';
import { BUTTON_STYLE } from '@latitude/core/utils/constants';

import Layout from '@/components/layout';
import AchPageHeaderSection from './_ach-page-header';
import LowRateMicrositeHeader from './../_low-rate-header';
import HeroBanner from '@/components/lab-components/HeroBanner';

const buttonHref = '/credit-cards/low-rate/addcard/ach-form/';

function AchAdditionalLandingPage(props) {
  const [urlButton, setUrlButton] = useState(null);

  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};
  /** - END - */

  useEffect(() => {
        if (window?.location){
          window.location.replace('https://latitudefs.zendesk.com/hc/en-au/articles/36591875170577-Additional-Cardholders')
        }
      },[])

  function fetchButtonHref() {
    if (window?.location?.search) {
      const queryParameters = new URLSearchParams(window.location.search);
      const applicationId = queryParameters.get('applicationid');

      if (applicationId) {
        return buttonHref + '?applicationid=' + applicationId;
      }
    }
    return null;
  }

  useEffect(() => {
    const href = fetchButtonHref();
    setUrlButton(href);
  }, []);

  return (
    <Layout location={props.location}>
      <main className="navigation-spacer">
        <Helmet>
          <link
            rel="canonical"
            href="https://www.latitudefinancial.com.au/credit-cards/low-rate/addcard/ach/"
          />
          <meta
            name="description"
            content="Welcome to the Latitude Low Rate Mastercard Mastercard® family"
          />
          <title>Additional Card Holder Welcome | Low Rate Mastercard</title>
        </Helmet>

        {state?.heroBannerData?.[0] ? (
          <HeroBanner {...state?.heroBannerData[0]} />
        ) : (
          <AchPageHeaderSection />
        )}
        <LowRateMicrositeHeader />

        <Section>
          <Heading4 css={{ color: '#1964B4' }}>
            Welcome to the Low Rate Mastercard&reg; family
          </Heading4>

          <div className="row">
            <div className="col-md-8">
              <p>
                Simply complete the online form to confirm your personal details
                such as full name, address and date of birth. You can use
                documents such as:
              </p>
              <p>
                <ul>
                  <li>Australian Driver's Licence</li>
                  <li>Australian Passport</li>
                  <li>Medicare card</li>
                </ul>
              </p>

              <p>
                Once complete your new Low Rate Mastercard will be sent to the account
                holders address within 5-7 working days.
              </p>
            </div>
            <div className="col-md-4">
              {urlButton ? (
                <Link
                  button={BUTTON_STYLE.SECONDARY}
                  css={{
                    margin: '0 auto',
                    width: 'fit-content'
                  }}
                  href={urlButton}
                >
                  Complete today
                </Link>
              ) : (
                <div
                  css={{
                    backgroundColor: '#777',
                    color: '#fff',
                    borderRadius: '4px',
                    padding: '12px 24px',
                    margin: '0 auto',
                    width: 'fit-content',
                    textAlign: 'center'
                  }}
                >
                  Missing Application ID
                </div>
              )}
            </div>
          </div>
        </Section>
      </main>
    </Layout>
  );
}

export default AchAdditionalLandingPage;
